import { forwardRef } from "react";

import Icon from "@/components/Icon";
import AiSparkSVG from "./ai-spark.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const AiSparkIconSVG = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={AiSparkSVG} {...props} />;
});

export default AiSparkIconSVG;
